module.exports = __webpack_public_path__ + "img/4-4.45bd6a6e.svg";